export default "__VITE_ASSET__CQ5WBGKT__"